export enum OrderRoutePaths {
    WELCOME = 'welcome',
    ORDER_SETUP = 'setup',
    ALL_SERVICES_DOWN = 'all-services-down',
    SERVICE_INFORMATION = 'service-information-collection',
    PREVIOUS_ADDRESS_COLLECTION = 'previous-address-collection',
    BUNDLE_HOMEPAGE = 'bundle-homepage',
    INTERNET_PACKAGE_SELECTION = 'internet-package-selection',
    VIDEO_PACKAGE_SELECTION = 'video-package-selection',
    VOICE_PACKAGE_SELECTION = 'voice-package-selection',
    VOICE_CONFIGURATION = 'voice-configuration',
    WIRELESS_SETUP = 'wireless-setup',
    BUSINESS_VERIFICATION = 'business-verification',
    CREDIT_CHECK = 'credit-check',
    CREDIT_RESULTS = 'credit-results',
    ADVANCED_BILL_PAYMENT = 'advanced-bill-payment',
    ADDITIONAL_INTERNET_OFFERS = 'additional-internet-offers',
    ADDITIONAL_VOICE_OFFERS = 'additional-voice-offers',
    ALTERNATE_SHIPPING = 'alternate-shipping-address',
    SERVICE_LEVEL_SELECTION = 'service-level-selection',
    CUSTOMER_ACCOUNT_SETUP = 'customer-account-setup',
    WINDSTREAM_CUSTOMER_ACCOUNT_SETUP = 'windstream-customer-account-setup',
    PRODUCT_SUMMARY = 'product-summary',
    TERMS_AND_CONDITIONS = 'terms-and-conditions',
    ORDER_CHECKLIST = 'order-checklist',
    NCVC_QUESTIONNAIRE = 'ncvc-questionnaire',
    ACCOUNT_REVIEW = 'account-review',
    CUSTOMER_ORDER_VERIFICATION = 'customer-order-verification',
    THIRD_PARTY_VERIFICATION = 'third-party-verification',
    INSTALLATION_SCHEDULING = 'installation-scheduling',
    PAYMENT_INFORMATION = 'payment-information-entry',
    INSTALLATION_CHECKLIST = 'installation-checklist',
    ORDER_SUMMARY = 'order-summary',
    ORDER_REVIEW = 'order-review',
    ORDER_OPTIONS = 'order-options',
    OUTSTANDING_BALANCE = 'outstanding-balance',
    STREAM_HARDWARE_SELECTION = 'stream-hardware-selection',
    SATELLITE_HARDWARE_SELECTION = 'satellite-hardware-selection',
    ADDITIONAL_VIDEO_OFFERS = 'additional-video-offers',
    ADDITIONAL_WIRELESS_OFFERS = 'additional-wireless-offers',
    EMAIL_VALIDATION = 'email-validation',
    REQUIRED_CALL = 'required-call',
    ADDITIONAL_CHANNEL_OFFERS = 'additional-channel-offers',
    CLOSING_OFFERS = 'closing-offers',
    STREAM_GENRE_PACK = 'stream-genre-pack',
    LINE_CONFIGURATION = 'line-configuration',
    SIGFAN = 'sigfan',
    CUSTOMER_SERVICE_SUMMARY = 'customer-service-summary',
    DTV_VIDEO_COMMERCIAL_SATELLITE_OFFERS = 'dtv-video-commercial-satellite-offers',
    MOBILE_BUSINESS_AGREEMENT = 'mobile-business-agreement'
}

export const OrderRoutes = {
    WELCOME: `/${OrderRoutePaths.WELCOME}`,
    ORDER_SETUP: `/order/${OrderRoutePaths.ORDER_SETUP}`,
    ALL_SERVICES_DOWN: `/order/${OrderRoutePaths.ALL_SERVICES_DOWN}`,
    SERVICE_INFORMATION: `/order/${OrderRoutePaths.SERVICE_INFORMATION}`,
    PREVIOUS_ADDRESS_COLLECTION: `/order/${OrderRoutePaths.PREVIOUS_ADDRESS_COLLECTION}`,
    BUNDLE_HOMEPAGE: `/order/${OrderRoutePaths.BUNDLE_HOMEPAGE}`,
    INTERNET_PACKAGE_SELECTION: `/order/${OrderRoutePaths.INTERNET_PACKAGE_SELECTION}`,
    VIDEO_PACKAGE_SELECTION: `/order/${OrderRoutePaths.VIDEO_PACKAGE_SELECTION}`,
    VOICE_PACKAGE_SELECTION: `/order/${OrderRoutePaths.VOICE_PACKAGE_SELECTION}`,
    VOICE_CONFIGURATION: `/order/${OrderRoutePaths.VOICE_CONFIGURATION}`,
    WIRELESS_SETUP: `/order/${OrderRoutePaths.WIRELESS_SETUP}`,
    BUSINESS_VERIFICATION: `/order/${OrderRoutePaths.BUSINESS_VERIFICATION}`,
    CREDIT_CHECK: `/order/${OrderRoutePaths.CREDIT_CHECK}`,
    CREDIT_RESULTS: `/order/${OrderRoutePaths.CREDIT_RESULTS}`,
    NCVC_QUESTIONNAIRE: `/order/${OrderRoutePaths.NCVC_QUESTIONNAIRE}`,
    ACCOUNT_REVIEW: `/order/${OrderRoutePaths.ACCOUNT_REVIEW}`,
    ORDER_REVIEW: `/order/${OrderRoutePaths.ORDER_REVIEW}`,
    ADVANCED_BILL_PAYMENT: `/order/${OrderRoutePaths.ADVANCED_BILL_PAYMENT}`,
    ADDITIONAL_INTERNET_OFFERS: `/order/${OrderRoutePaths.ADDITIONAL_INTERNET_OFFERS}`,
    ADDITIONAL_VOICE_OFFERS: `/order/${OrderRoutePaths.ADDITIONAL_VOICE_OFFERS}`,
    ALTERNATE_SHIPPING: `/order/${OrderRoutePaths.ALTERNATE_SHIPPING}`,
    SERVICE_LEVEL_SELECTION: `/order/${OrderRoutePaths.SERVICE_LEVEL_SELECTION}`,
    CUSTOMER_ACCOUNT_SETUP: `/order/${OrderRoutePaths.CUSTOMER_ACCOUNT_SETUP}`,
    WINDSTREAM_CUSTOMER_ACCOUNT_SETUP: `/order/${OrderRoutePaths.WINDSTREAM_CUSTOMER_ACCOUNT_SETUP}`,
    PRODUCT_SUMMARY: `/order/${OrderRoutePaths.PRODUCT_SUMMARY}`,
    TERMS_AND_CONDITIONS: `/order/${OrderRoutePaths.TERMS_AND_CONDITIONS}`,
    ORDER_CHECKLIST: `/order/${OrderRoutePaths.ORDER_CHECKLIST}`,
    CUSTOMER_ORDER_VERIFICATION: `/order/${OrderRoutePaths.CUSTOMER_ORDER_VERIFICATION}`,
    THIRD_PARTY_VERIFICATION: `/order/${OrderRoutePaths.THIRD_PARTY_VERIFICATION}`,
    PAYMENT_INFORMATION: `/order/${OrderRoutePaths.PAYMENT_INFORMATION}`,
    INSTALLATION_CHECKLIST: `/order/${OrderRoutePaths.INSTALLATION_CHECKLIST}`,
    ORDER_SUMMARY: `/order/${OrderRoutePaths.ORDER_SUMMARY}`,
    INSTALLATION_SCHEDULING: `/order/${OrderRoutePaths.INSTALLATION_SCHEDULING}`,
    ORDER_OPTIONS: `/order/${OrderRoutePaths.ORDER_OPTIONS}`,
    OUTSTANDING_BALANCE: `/order/${OrderRoutePaths.OUTSTANDING_BALANCE}`,
    STREAM_HARDWARE_SELECTION: `/order/${OrderRoutePaths.STREAM_HARDWARE_SELECTION}`,
    SATELLITE_HARDWARE_SELECTION: `/order/${OrderRoutePaths.SATELLITE_HARDWARE_SELECTION}`,
    ADDITIONAL_VIDEO_OFFERS: `/order/${OrderRoutePaths.ADDITIONAL_VIDEO_OFFERS}`,
    ADDITIONAL_WIRELESS_OFFERS: `/order/${OrderRoutePaths.ADDITIONAL_WIRELESS_OFFERS}`,
    EMAIL_VALIDATION: `/order/${OrderRoutePaths.EMAIL_VALIDATION}`,
    REQUIRED_CALL: `/order/${OrderRoutePaths.REQUIRED_CALL}`,
    ADDITIONAL_CHANNEL_OFFERS: `/order/${OrderRoutePaths.ADDITIONAL_CHANNEL_OFFERS}`,
    CLOSING_OFFERS: `/order/${OrderRoutePaths.CLOSING_OFFERS}`,
    STREAM_GENRE_PACK: `/order/${OrderRoutePaths.STREAM_GENRE_PACK}`,
    LINE_CONFIGURATION: `/order/${OrderRoutePaths.LINE_CONFIGURATION}`,
    SIGFAN: `/order/${OrderRoutePaths.SIGFAN}`,
    CUSTOMER_SERVICE_SUMMARY: `/order/${OrderRoutePaths.CUSTOMER_SERVICE_SUMMARY}`,
    DTV_VIDEO_COMMERCIAL_SATELLITE_OFFERS: `/order/${OrderRoutePaths.DTV_VIDEO_COMMERCIAL_SATELLITE_OFFERS}`,
    MOBILE_BUSINESS_AGREEMENT: `/order/${OrderRoutePaths.MOBILE_BUSINESS_AGREEMENT}`
} as const
